import { VertexBuffer } from '@babylonjs/core/Meshes/buffer';
import { Mesh } from '@babylonjs/core/Meshes/mesh';

/** This will mutate the mesh geometry. Only use this on temp/intermediate mesh data */
export function ensureNormalsExist(mesh: Mesh) {
    if (!mesh.getVerticesData(VertexBuffer.NormalKind)) {
        mesh.createNormals(true);
        mesh.convertToFlatShadedMesh();
    }
}
